export default "__VITE_ASSET__ApHz8tij__"